import { render, staticRenderFns } from "./Taginput.vue?vue&type=template&id=9fa3a15c&"
import script from "./Taginput.vue?vue&type=script&lang=js&"
export * from "./Taginput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports